import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { showUpdate, remove, update, create, setPaginaAtual } from './grupoActions';
import SPButton from '../common/form/spButton';
import swal from 'sweetalert2';
import ReactTableGT2A from '../common/grid/gridReactTable';
import PremiumTableShell from '../common/grid/premiumTableShell';
import PermissaoUsuario from '../auth/permissao';

class GrupoList extends Component {
  removerGrupo(data) {
    swal({
      title: 'Deseja realmente excluir?',
      type: 'question',
      showCancelButton: true,
      confirmButtonColor: 'primary',
      confirmButtonText: 'Sim',
      cancelButtonText: 'Não',
      allowOutsideClick: 'false',
    }).then(result => {
      if (result.value) {
        this.props.remove(data);
      }
    });
  }

  handlePageChange = page => {
    this.props.setPaginaAtual(page);
  };

  render() {
    const grupo = this.props.list || [];
    const paginaAtual = this.props.paginaAtual;

    const columns = [
      {
        Header: 'Ações',
        Cell: row => (
          <div>
            <PermissaoUsuario tela="CadGrupo" condicao={true}>
              <SPButton
                type="button"
                className="warning btn-sm"
                icon="pencil-alt"
                data-title="Alterar"
                onClick={() => this.props.showUpdate(row.original)}
              />
              <SPButton
                type="button"
                className="danger btn-sm"
                icon="trash-alt"
                data-title="Excluir"
                onClick={() => this.removerGrupo(row.original)}
              />
            </PermissaoUsuario>
            <PermissaoUsuario tela="CadGrupo" condicao={false}>
              <SPButton type="button" className="warning btn-sm" icon="pencil-alt" disabled="disabled" />
              <SPButton type="button" className="danger btn-sm" icon="trash-alt" disabled="disabled" />
            </PermissaoUsuario>
          </div>
        ),
        className: 'column_icon',
        width: 90,
        resizable: true,
        Filter: () => (
          <div className="rt-th">
            <span>Filtrar</span>
          </div>
        ),
      },
      {
        Header: 'Código',
        accessor: 'id',
        minWidth: 60,
        maxWidth: 100,
        filterable: true,
        resizable: true,
        className: 'column_grid column_center',
      },
      {
        Header: 'Descrição',
        accessor: 'descricao',
        minWidth: 200,
        className: 'column_grid',
        filterable: true,
        resizable: true,
      },
    ];

    return (
      <div className="table-container" style={{ marginTop: '20px', width: '100%' }}>
        <style>{`
                    .grupo-premium-table .ReactTable .rt-th.column_center,
                    .grupo-premium-table .ReactTable .rt-td.column_center {
                        justify-content: center;
                        text-align: center;
                    }

                    .grupo-premium-table .ReactTable .rt-th.column_grid:not(.column_center),
                    .grupo-premium-table .ReactTable .rt-td.column_grid:not(.column_center) {
                        justify-content: flex-start;
                        text-align: left;
                    }

                    .grupo-premium-table .ReactTable .rt-th .rt-resizable-header-content,
                    .grupo-premium-table .ReactTable .rt-th .rt-th-content {
                        width: 100%;
                        text-align: center;
                        justify-content: center;
                    }

                    .grupo-premium-table .ReactTable .rt-td,
                    .grupo-premium-table .ReactTable .rt-th {
                        font-size: 12px;
                    }
                `}</style>

        <div className="grupo-premium-table">
          <PremiumTableShell summary={`${grupo.length} grupo(s) exibido(s)`} tableMinWidth={0}>
            <ReactTableGT2A
              data={grupo}
              columns={columns}
              className="-striped -highlight"
              defaultPageSize={15}
              showPagination
              filterable={true}
              onPageChange={this.handlePageChange}
              page={paginaAtual}
              style={{
                fontSize: '13px',
                width: '100%',
              }}
            />
          </PremiumTableShell>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  list: state.grupoCad.list,
  paginaAtual: state.grupoCad.paginaAtual,
});
const mapDispatchToProps = dispatch =>
  bindActionCreators({ showUpdate, remove, update, create, setPaginaAtual }, dispatch);
export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(GrupoList);
